import { defineMessages } from 'react-intl-next';

export const messages: {
	showMoreLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showAllAppsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMoreLabel: {
		id: 'search-page.app-filter-sidebar.show-more.button.label',
		defaultMessage: 'Show more',
		description: 'Label for the button that opens the show more apps dialog',
	},
	showAllAppsLabel: {
		id: 'search-page.app-filter-sidebar.show-all-apps.button.label',
		defaultMessage: 'Show all apps',
		description:
			'Label for the button that opens the show all apps dialog in single-select variant',
	},
	filterPlaceholder: {
		id: 'search-page.app-filter-sidebar.show-more.filter.placeholder',
		defaultMessage: 'Find apps',
		description: 'Placeholder for the filter input in the show more apps dialog',
	},
});
